export const API_URL = "https://fastfurniture.azurewebsites.net";
export const API_LAYER_URL = "https://apilayer.azurewebsites.net";
//export const API_LAYER_URL = "http://localhost:7071";
//export const API_URL = "http://localhost:8001";



// WEBPACK FOOTER //
// ./src/config.js